<div class="card">
    <div class="border-bottom title-part-padding">
        <h4 class="card-title mb-0">Create a new template</h4>
    </div>
    <div class="card-body">
        <div class="template-form-container">
            <form id="template-form"
                  class="form-horizontal">

                <div class="mb-3">
                    <label class="form-label">Name<span class="help"> e.g. "Invoice Template"</span>
                    </label>
                    <input type="text"
                           class="form-control"
                           value=""
                           name="name"
                           placeholder="Please specify the name" required>
                    <div class="invalid-feedback">Required</div>
                </div>

                <div class="mb-3">
                    <label class="form-label">Description</label>
                    <textarea class="form-control"
                              name="description"
                              rows="5"></textarea>
                </div>

                <div id="dropzone-wrapper">
                    <label class="form-label">Proposal Document (.docx)</label>
                    <div id="dropzone-container" class="dropzone-container">
                        <div id="dropzone" class="dropzone">
                            <svg class="dropzone-icon" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p class="dropzone-text">
                                <span>Click to upload</span> or drag and drop
                            </p>
                            <p class="dropzone-subtext">DOCX only, max 10MB</p>
                        </div>
                        <input type="file" id="file-upload" name="fileUpload" accept=".docx">
                    </div>
                </div>

                <!-- File Info Display -->
                <div id="file-info-container" class="file-info-wrapper">
                    <!-- This div will be populated by JavaScript -->
                </div>


                <div class="card-body border-top mt-6">
                    <button type="button"
                            data-id="submit-form"
                            class="btn btn-primary">
                        Save
                    </button>
                    <a href="/template/list" class="btn bg-danger-subtle text-danger ms-6">
                        Cancel
                    </a>
                </div>

            </form>
        </div>
    </div>
</div>
